import React, { useEffect, useState } from 'react';
import { ssoService, SSOUser } from '../shared/ssoService';
import './SalesDashboard.css';

const SalesDashboard: React.FC = () => {
  const [user, setUser] = useState<SSOUser | null>(null);

  useEffect(() => {
    const loadUser = async () => {
      const currentUser = await ssoService.getCurrentUser();
      setUser(currentUser);
    };
    loadUser();
  }, []);

  const handleLogout = async () => {
    await ssoService.logout();
  };

  return (
    <div className="sales-dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <div className="dashboard-navbar-brand">
            <img src="https://syberkey.com/images/logo.png" alt="SyberKey Logo" className="dashboard-logo-img" />
            <div className="dashboard-brand-text">
              <div className="dashboard-brand-name">
                Syber<span className="brand-yellow">Key</span>
              </div>
            </div>
            <span style={{ marginLeft: '1rem', color: 'var(--muted)', fontSize: '0.9rem' }}>• Sales</span>
          </div>
          <div className="user-info">
            {user && <span className="user-email">{user.email}</span>}
            <button onClick={handleLogout} className="logout-btn">Logout</button>
          </div>
        </div>
      </header>

      <main className="dashboard-content">
        <div className="welcome-section">
          <h2>Sales Management Dashboard</h2>
          <p>Track your sales pipeline and customer relationships</p>
        </div>

        <div className="stats-grid">
          <div className="stat-card">
            <div className="stat-icon">📊</div>
            <div className="stat-info">
              <h3>Total Revenue</h3>
              <p className="stat-value">$1.2M</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">🎯</div>
            <div className="stat-info">
              <h3>Active Deals</h3>
              <p className="stat-value">24</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">👥</div>
            <div className="stat-info">
              <h3>Customers</h3>
              <p className="stat-value">156</p>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">📈</div>
            <div className="stat-info">
              <h3>Conversion Rate</h3>
              <p className="stat-value">32%</p>
            </div>
          </div>
        </div>

        <div className="content-section">
          <h3>Recent Deals</h3>
          <div className="deals-list">
            <div className="deal-item">
              <div className="deal-info">
                <strong>Enterprise Corp</strong>
                <span className="deal-value">$45,000</span>
              </div>
              <span className="deal-stage success">Closed</span>
            </div>
            <div className="deal-item">
              <div className="deal-info">
                <strong>Tech Solutions Inc</strong>
                <span className="deal-value">$28,500</span>
              </div>
              <span className="deal-stage pending">In Progress</span>
            </div>
            <div className="deal-item">
              <div className="deal-info">
                <strong>Global Industries</strong>
                <span className="deal-value">$67,000</span>
              </div>
              <span className="deal-stage pending">Negotiation</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SalesDashboard;
